import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "../components/Footer";
import { ShieldCheck, Archive, Headphones } from "lucide-react";
import { Zap, Clock, Settings} from 'lucide-react';
import { Truck, Users, Box, Layers, Infinity } from 'lucide-react';
import IrsMaintenanceBanner from "./IrsMaintenanceBanner";
export default function Home({ isAuthenticated ,setIsAuthenticated}) {
const fileLink = isAuthenticated ? "/dashboard" : "/sign-up";
  useEffect(() => {
    // 1) Синхронная проверка наличия
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    // 2) Локальная проверка JWT-exp (опционально)
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.exp * 1000 < Date.now()) {
        throw new Error("expired");
      }
    } catch {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      return;
    }

    // 3) Серверная валидация
    fetch("/api/users-logic/me/", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) {
          localStorage.removeItem("token");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      })
      .catch(() => {
        // по желанию можно сюда тоже сетать false, 
        // или оставить isAuthenticated как есть до восстановления сети
      });
  }, [setIsAuthenticated]);
  return (
    <div className="bg-white text-[#0F2C5E] flex flex-col min-h-screen font-sans">
      <Header isAuthenticated={isAuthenticated} />
      <main className="flex-grow">
        {/* Hero */}
        <section className="bg-[#0F2C5E] text-white py-16 sm:py-20 px-4">
        <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-10">
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-snug">
              Trusted IRS Authorized Service for Form 2290 Filing
            </h1>
            <p className="text-sm sm:text-base text-white/90 mb-6">
              Fast, reliable and IRS-compliant. Accessible on any device.
            </p>
            <Link to={fileLink} className="inline-flex items-center justify-center lg:justify-start gap-4">
              <button className="bg-white text-[#0F2C5E] px-6 py-3 rounded-md text-sm font-semibold hover:bg-gray-200 transition uppercase">
                File Form
              </button>
              <img
                src="/images.png"
                alt="Authorized IRS e-file Provider"
                className="h-12 w-auto rounded-md"
              />
            </Link>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mt-8">
              <div>
                <p className="text-2xl font-bold">1200+</p>
                <p className="text-white/80 text-sm">Active Companies</p>
              </div>
              <div>
                <p className="text-2xl font-bold">800+</p>
                <p className="text-white/80 text-sm">Clients Trust Us</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 flex justify-center">
            <img
              src="/hero2290.png"
              alt="Form 2290 Illustration"
              className="w-full max-w-[300px] sm:max-w-[350px] h-auto rounded-lg shadow-md object-contain "
            />
          </div>
        </div>
      </section>
          {/* New Feature Block */}
        {/* New Feature Block */}
      <section className="py-16 bg-white px-4">
        <div className="max-w-7xl mx-auto">
          {/* Заголовок над двумя колонками */}
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            Say Goodbye to the Complicated and Time-Consuming Form 2290
          </h2>

          <div className="flex flex-col lg:flex-row items-start gap-12">
            {/* Левая колонка – картинка */}
            <div className="w-full lg:w-1/2">
              <img
                src="/Frame19.png"
                alt="Driver using mobile device"
                className="w-full h-auto rounded-lg shadow-md object-cover"
              />
            </div>

            {/* Правая колонка – текст */}
            <div className="w-full lg:w-1/2 lg:pl-12">
              <ul className="space-y-3 mb-6 list-disc list-inside text-gray-700">
                <li>
                  <span className="font-semibold text-[#0F2C5E]">Speed:</span> Complete the filing process in just a few minutes and receive your Schedule 1 instantly after submission.
                </li>
                <li>
                  <span className="font-semibold text-[#0F2C5E]">Convenience:</span> Available 24/7 – no need to wait for office hours.
                </li>
                <li>
                  <span className="font-semibold text-[#0F2C5E]">Time-Saving:</span> Skip the long lines and tedious manual paperwork.
                </li>
                <li>
                  <span className="font-semibold text-[#0F2C5E]">Error Reduction:</span> Built-in error checks help prevent common mistakes.
                </li>
              </ul>

              {/* Новый текстовый блок */}
              <p className="text-gray-600 mb-8">
                Filing Form 2290 doesn’t have to be complicated. Simplify the process and save valuable time with our easy-to-use online platform. Click below to begin now!
              </p>

              <Link to={fileLink}>
                <button
                  className="w-full sm:w-auto bg-[#0F2C5E] text-white px-16 py-3 rounded-md hover:bg-[#173B6F] transition"
                >
                  Try Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>


        {/* Why File */}
       <section className="py-14 bg-white px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-xl sm:text-2xl font-bold uppercase tracking-wider mb-8">
            Why File Online?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            <div className="flex flex-col items-center text-center p-4">
              <Zap size={32} className="mb-2 text-[#0F2C5E]" />
              <span className="font-semibold">Speed</span>
              <p className="text-sm mt-1">Get Schedule 1 instantly.</p>
            </div>
            <div className="flex flex-col items-center text-center p-4">
              <Clock size={32} className="mb-2 text-[#0F2C5E]" />
              <span className="font-semibold">24/7 Access</span>
              <p className="text-sm mt-1">File anytime from any device.</p>
            </div>
            <div className="flex flex-col items-center text-center p-4">
              <Settings size={32} className="mb-2 text-[#0F2C5E]" />
              <span className="font-semibold">Efficiency</span>
              <p className="text-sm mt-1">Avoid paperwork & office visits.</p>
            </div>
            <div className="flex flex-col items-center text-center p-4">
              <ShieldCheck size={32} className="mb-2 text-[#0F2C5E]" />
              <span className="font-semibold">Accuracy</span>
              <p className="text-sm mt-1">Built-in checks prevent errors.</p>
            </div>
          </div>
        </div>
      </section>

        {/* Features */}
        <section className="py-14 bg-gray-50 px-4">
          <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center">
            <div>
              <ShieldCheck className="mx-auto w-10 h-10 mb-3" />
              <h3 className="text-lg font-semibold mb-1">IRS Authorized</h3>
              <p className="text-sm text-gray-600">We meet the highest IRS security standards.</p>
            </div>
            <div>
              <Archive className="mx-auto w-10 h-10 mb-3" />
              <h3 className="text-lg font-semibold mb-1">History Archive</h3>
              <p className="text-sm text-gray-600">Secure VIN & form history storage.</p>
            </div>
            <div>
              <Headphones className="mx-auto w-10 h-10 mb-3" />
              <h3 className="text-lg font-semibold mb-1">US Support</h3>
              <p className="text-sm text-gray-600">Real support from U.S. experts.</p>
            </div>
          </div>
        </section>

       {/* Pricing */}
        <section className="py-14 bg-white px-4 text-center">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-xl sm:text-2xl font-bold mb-8 uppercase tracking-wide">
              Pricing
            </h2>

            {/* Первый ряд: 4 карточки */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { label: "1 Vehicle",      price: "$19.99",   icon: Truck     },
                { label: "2–24 Vehicles",  price: "$24.99",   icon: Users     },
                { label: "25–100 Vehicles",price: "$34.99",   icon: Box       },
                { label: "101–250 Vehicles",price:"$49.99",   icon: Layers    },
              ].map((plan, i) => (
                <div
                  key={i}
                  className="bg-gray-100 p-6 rounded-lg shadow-sm flex flex-col items-center"
                >
                  <plan.icon size={48} className="mb-4 text-[#0F2C5E]" />
                  <p className="text-sm font-medium mb-1">{plan.label}</p>
                  <p className="text-2xl font-bold text-[#0F2C5E] mb-4">
                    {plan.price}
                  </p>
                  <Link to={fileLink} className="w-full">
                    <button className="w-full bg-[#0F2C5E] text-white py-2 rounded hover:bg-[#173B6F] transition text-sm">
                      File Now
                    </button>
                  </Link>
                </div>
              ))}
            </div>

            {/* Второй ряд: 3 карточки, отцентрованы */}
            <div className="flex justify-center mt-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  { label: "251–1000 Vehicles", price: "$74.99", icon: Infinity },
                  { label: "1001+ Vehicles",     price: "$99.99", icon: Truck    },
                  { label: "Unlimited (1 company, 1 tax year)", price: "$199", icon: Infinity },
                ].map((plan, i) => (
                  <div
                    key={i}
                    className="bg-gray-100 p-6 rounded-lg shadow-sm flex flex-col items-center"
                  >
                    <plan.icon size={48} className="mb-4 text-[#0F2C5E]" />
                    <p className="text-sm font-medium mb-1">{plan.label}</p>
                    <p className="text-2xl font-bold text-[#0F2C5E] mb-4">
                      {plan.price}
                    </p>
                    <Link to={fileLink} className="w-full">
                      <button className="w-full bg-[#0F2C5E] text-white py-2 rounded hover:bg-[#173B6F] transition text-sm">
                        File Now
                      </button>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* Video */}
        <section className="py-14 bg-gray-100 text-center px-4">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 uppercase">How to File Form 2290</h2>
          <p className="mb-6 text-gray-600 text-sm">Watch this short guide to learn the process.</p>
          <div className="aspect-video max-w-4xl mx-auto rounded overflow-hidden shadow-md">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/AHquoaRCVDY"
              title="How to File Form 2290"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </section>

        {/* Other Services */}
        <section className="py-14 bg-white px-4">
          <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[{ title: "UCR Online Filing", desc: "Quick and easy UCR compliance submission." }, { title: "BOC-3 Filing", desc: "Appoint process agents online in minutes." }].map(({ title, desc }, i) => (
              <div key={i} className="bg-gray-100 p-6 rounded">
                <h3 className="font-semibold text-lg mb-2">{title}</h3>
                <p className="text-sm text-gray-600 mb-4">{desc}</p>
                <Link to={fileLink}>
                  <button className="w-full py-2 bg-[#0F2C5E] text-white rounded hover:bg-[#173B6F] text-sm">
                    File {title.split(' ')[0]}
                  </button>
                </Link>
              </div>
            ))}
          </div>
        </section>

        {/* Due Dates */}
        <section className="py-14 bg-gray-50 text-center px-4">
          <h2 className="text-xl sm:text-2xl font-bold mb-8 uppercase">Form 2290 Due Dates</h2>
          <div className="overflow-x-auto">
            <table className="mx-auto w-full max-w-3xl text-sm">
              <thead className="bg-[#0F2C5E] text-white">
                <tr>
                  <th className="p-2">Month Vehicle First Used</th>
                  <th className="p-2">Due Date</th>
                </tr>
              </thead>
              <tbody>
                {["July", "August", "September", "October", "November", "December", "January", "February", "March", "April", "May", "June"].map((month, i) => {
                  const dueDates = ["August 31", "September 30", "October 31", "November 30", "December 31", "January 31", "Last day of February", "March 31", "April 30", "May 31", "June 30", "July 31"];
                  return (
                    <tr key={i} className="even:bg-white odd:bg-gray-100">
                      <td className="p-2">{month}</td>
                      <td className="p-2">{dueDates[i]}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="mt-6 text-xs text-gray-500 max-w-xl mx-auto">
            Filing late? Avoid penalties by submitting Form 2290 before the deadline.
          </p>
        </section>

        {/* FAQ */}
        <section className="py-14 bg-white px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-xl sm:text-2xl font-bold mb-8 uppercase text-center">Quick Answers</h2>
            <div className="space-y-4">
              {[
                "What is Form 2290?",
                "When is Form 2290 due?",
                "Do I need an EIN to file?",
                "How fast do I get Schedule 1?",
                "Is e-filing mandatory?"
              ].map((q, i) => {
                const a = [
                  "Form 2290 is a U.S. tax form for reporting Heavy Vehicle Use Tax (HVUT).",
                  "Due the last day of the month after the vehicle's first use.",
                  "Yes. An EIN is required to file. SSNs aren't accepted.",
                  "Usually within minutes after submission & payment.",
                  "Yes, if you're reporting 25 or more vehicles."
                ];
                return (
                  <details key={i} className="border border-gray-300 rounded">
                    <summary className="px-4 py-3 font-semibold bg-gray-50 hover:bg-gray-100 cursor-pointer select-none">
                      {q}
                    </summary>
                    <div className="px-4 py-2 text-sm text-gray-700">{a[i]}</div>
                  </details>
                );
              })}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
